import { render, staticRenderFns } from "./OnlineCashesButtonCertificate.vue?vue&type=template&id=6b152ddc"
import script from "./OnlineCashesButtonCertificate.vue?vue&type=script&lang=js"
export * from "./OnlineCashesButtonCertificate.vue?vue&type=script&lang=js"
import style0 from "./OnlineCashesButtonCertificate.vue?vue&type=style&index=0&id=6b152ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports